import { render, staticRenderFns } from "./InactiveClientAlert.vue?vue&type=template&id=734e9654&lang=pug"
import script from "./InactiveClientAlert.vue?vue&type=script&lang=js"
export * from "./InactiveClientAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Name: require('/home/docker/code/frontend/components/Name.vue').default})
